import { JBaseApi } from '../base';
import { OF } from '../../util/network';
import { AdminApps } from '../../types/adminUtils';

export class AdminUtilsApi extends JBaseApi {
    /**
     * Request the admin applications and sub applications for the admin panel
     */
    public getApps(signal?: AbortSignal) {
        return this.network.post<AdminApps>(
            {
                o: 'admin',
                f: 'apps',
            } as OF,
            signal,
        );
    }
}
